import { LoadingStates } from '@pb/utils'

import { MembershipDetail } from './types'

const getMembershipDetailsLoadingState = (state): LoadingStates =>
  state.account.membershipInfo.membershipLoadingState
const getIsMembershipDetailLoading = (state): boolean =>
  getMembershipDetailsLoadingState(state) === LoadingStates.Loading
const getIsMembershipDetailLoaded = (state): boolean =>
  getMembershipDetailsLoadingState(state) === LoadingStates.LoadedSuccess
const getIsMembershipDetailFailed = (state): boolean =>
  getMembershipDetailsLoadingState(state) === LoadingStates.LoadedFail
const getMembershipDetail = (state): MembershipDetail =>
  state.account.membershipInfo.membershipDetail || null

export default {
  getMembershipDetailsLoadingState,
  getIsMembershipDetailLoading,
  getIsMembershipDetailLoaded,
  getIsMembershipDetailFailed,
  getMembershipDetail,
}
